import React from 'react';
import styles from "./myprofile.module.css"
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu';
import VendorProfileBody from '../../Components/vendorprofilebody/VendorProfileBody';

const Vendorprofile = () => {
    return (
        <>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <VendorProfileMenu />
                </div>
                    <VendorProfileBody />
            </div>


        </>
    );
};

export default Vendorprofile;
